import React from 'react';

import { useParams } from 'react-router';

import { Box, CircularProgress } from '@mui/material';

import { useGetBusinessSettings } from '~/hooks/apis/business-traveller/useBusinessSettings';

import BusinessSettingTabContent from '../../../components/businessSettings/BusinessSettingTabContent';

interface Params {
  businessId: string;
}

export default function BusinessSettingTab() {
  const { businessId } = useParams<Params>();
  const { data: settings = {}, isFetching, error } = useGetBusinessSettings(businessId);

  if (isFetching) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return <BusinessSettingTabContent businessId={businessId} initialSettings={settings} error={error} />;
}
